import React from "react";
import {
  createAmplifyAuthAdapter,
  createStorageBrowser,
} from '@aws-amplify/ui-react-storage/browser';
import { useNavigate } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import {
  Grid,
  Divider,
  Box,
  Typography,
  Card,
  CardActions,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  TextField,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditCompanyProfile from "../components/companyProfile/CompanyProfileEdit";
import { toast } from 'react-toastify';
import axios from "axios";
import { cfg } from "../config";
import { fetchAuthSession } from 'aws-amplify/auth';
import ContentLoading from "../components/common/ContentLoading";
import { signOutFromApp } from "../helpers";

const Documentation = (props) => {
  const navigate = useNavigate();

  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [deleteDialogOpened, setDeleteDialogOpened] = React.useState(false);
  const [deleteText, setDeleteText] = React.useState("");

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetchAuthSession()
      .then((session) => {
        axios
          .get(`${cfg.apiUrl}/org`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: session.tokens?.idToken,
            },
          })
          .then((resp) => {
            console.log(resp);
            setData(resp.data);
            setIsLoading(false);
            console.log(data);
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const manageBilling = () => {
    console.log(window.location.href);
    let data = { returnUrl: window.location.href }; // The return URL is the Company Profile page
    fetchAuthSession()
      .then((session) => {
        axios
          .post(
            `${cfg.apiUrl}/create-customer-portal-session`,
            {
              ...data,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: session.tokens?.idToken,
              },
            }
          )
          .then((resp) => {
            console.log(resp.data.sessionUrl);
            window.location = resp.data.sessionUrl;
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const checkout = (plan) => {
    console.log(window.location.href);
    let data = {
      plan,
      successUrl: window.location.href,
      cancelUrl: window.location.href,
    };
    fetchAuthSession()
      .then((session) => {
        axios
          .post(
            `${cfg.apiUrl}/create-checkout-session`,
            {
              ...data,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: session.tokens?.idToken,
              },
            }
          )
          .then((resp) => {
            console.log(resp.data.sessionUrl);
            window.location = resp.data.sessionUrl;
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteAccount = () => {
    setIsLoading(true);

    fetchAuthSession()
      .then((session) => {
        axios
          .delete(`${cfg.apiUrl}/org`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: session.tokens?.idToken,
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              setDeleteDialogOpened(false);
            } else {
              setDeleteDialogOpened(false);
              toast.error(
                "Something went wrong, please see console for details.",
                "ERROR"
              );
              console.log(resp);
            }

            // Sign out
            signOutFromApp(navigate); // TODO: FIX
          })
          .catch((e) => {
            console.log(e);
            if (e.response || e.request) {
              toast.error(
                "Something went wrong, please see console for details.",
                "ERROR"
              );
            } else {
              toast.error(
                "Something went wrong, please see console for details.",
                "ERROR"
              );
            }

            setIsLoading(false);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const changeDeleteText = (e) => {
    setDeleteText(e.target.value);
  };

  const cancelDialog = () => {
    setDeleteDialogOpened(false);
    setDeleteText(""); // reset delete text
  };

  const { StorageBrowser } = createStorageBrowser({
    config: createAmplifyAuthAdapter(),
  });

  return (
    <div>
      {isLoading ? (
        <div>
          <ContentLoading />
        </div>
      ) : (
        <>
          <Grid container spacing={2}>
            {data.billing.plan && (
              <Grid size={{ md: 12 }}>
                <Card>
                  <CardContent>
                    <Grid container spacing={6} alignItems="center">
                      <Grid size={{ xs: 11 }}>
                        <Box p={1}>
                          <Typography variant={"h6"}>Documentation</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    <StorageBrowser/>
                  </CardContent>
                </Card>
              </Grid>
            )}



          </Grid>

        </>
      )}
    </div>
  );
};
export default Documentation;
